// Membership follows the reviewed baseline and corrective stack, not version ordering.
// Keep this set aligned with review_attempt_rows_v1's authorized engine set.
export const CURRENT_STACK_ID = '9ca0d1b9-d993-41b1-bbf4-eedca36ba7df';
export const CURRENT_STACK_ENGINES = Object.freeze(['28', '29', '30', '32', '33'].map(
  patch => `rosetta-v3-deterministic-sql-2.5.${patch}`,
));
export function isCurrentStackEngine(engine) {
  return CURRENT_STACK_ENGINES.includes(engine);
}
export function assertCurrentStackPage(page) {
  if (!page || !Array.isArray(page.laws) || page.laws.some(row => row.engine_version && !isCurrentStackEngine(row.engine_version))) {
    throw new Error('Current-stack evidence is unavailable. No retired-engine result has been substituted.');
  }
  return page;
}
